export default () => ({
  currentUser: {},
  users: [],
  divisions: [],
})
